<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-06-09 09:49:10
 * @LastEditTime: 2020-09-27 09:59:33
 * @Description: 
--> 
<template>
  <Drawer width="400" title="邀请员工" v-model="drawerOpened">
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem label="手机号" prop="mobile">
          <Input v-model="formItem.mobile" placeholder="输入名字..." />
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">邀请</Button>
          <Button @click="handleSubmit('formItem')" style="margin-left: 12px"
            >继续邀请</Button
          >
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "InviteUserDrawer",
  components: {},
  props: [],
  data() {
    return {
      drawerOpened: false,
      selectedDepartment: null,
      formItem: {
        mobile: "",
      },
      ruleValidate: {
        mobile: [{ required: true, message: "名字为必填项", trigger: "blur" }],
      },
    };
  },
  methods: {
    ...mapActions("company", ["inviteUser"]),
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            await this.inviteUser({
              mobile: this.formItem.mobile,
            });
            this.$Message.success("保存成功!");
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
    openDrawer(data) {
      this.drawerOpened = true;
    },
  },
};
</script>

<style scoped lang="stylus"></style>
